import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Form, Row, Select, Input, Spin, Modal, Tag } from 'antd';
import { t } from 'i18next';
import deburr from 'lodash/deburr';
import { Button } from '../components/buttons/buttons';
import formHelper from '../utility/formHelper';
import { SpinerCustomStyle } from '../container/styled';
import serviceHelper from '../utility/serviceHelper';
import { DataService } from '../config/dataService/dataService_yerbis';

function ProjeYonetimi({ visible, onCancel }) {
  const [formBarkodNo] = Form.useForm();
  const [formProjeGuncelle] = Form.useForm();
  const { Option } = Select;

  const initialProjeBilgileri = {
    projeStr: '',
    projeAdi: '',
    projeIlStr: '',
    projeIlceStr: '',
    projeMahalleStr: '',
    projeKontrolKurumuStr: '',
    projeEtutTuru: '',
    projeFirmaStr: '',
    projeOlcekStr: '',
    projeProjeksiyon: '',
  };

  const [loading, setLoading] = useState(true);
  const [contentType, setContentType] = useState(1);
  const [projeBilgileri, setProjeBilgileri] = useState(initialProjeBilgileri);
  const [ilListesi, setIlListesi] = useState([]);
  const [ilceListesi, setIlceListesi] = useState([]);
  const [mahalleListesi, setMahalleListesi] = useState([]);
  const [kurumListesi, setKurumListesi] = useState([]);
  const [etutTuruListesi, setEtutTuruListesi] = useState([]);
  const [firmaListesi, setFirmaListesi] = useState([]);
  const [olcekListesi, setOlcekListesi] = useState([]);
  const [projeksiyonListesi, setProjeksiyonListesi] = useState([]);

  const diziBirlestir = (arr) => {
    if (!Array.isArray(arr)) return arr;
    if (arr.length === 1) return arr[0];
    return arr.join(',');
  };

  const getIlList = async () => {
    try {
      const res = await DataService.get('/TanimTur/GetIlListesi', null, true);
      return res.data.model || [];
    } catch (e) {
      return [];
    }
  };

  const getTumIlceler = async (ilIds) => {
    const response = await serviceHelper.IlceListesiMultiSelect(ilIds);
  };

  const getTumMahalleler = async (ilceIds) => {
    const response = await serviceHelper.MahalleListesiMultiSelect(ilceIds);
  };

  const projeyiBul = async () => {
    setLoading(true);
    const values = formHelper.getFormValues(formBarkodNo);
    if (!formHelper.isEmptyFieldVal(values)) {
      const res = await formHelper.formSubmit(`${process.env.REACT_APP_PROJE_BUL_BARKOD_ADMIN}`, values, 'post', true);

      if (res.responseStatus && res.responseData.isSuccess) {
        setProjeBilgileri(res.responseData.model);
        const [resIlceListesi, resMahalleListesi, resKurumList, resEtutTuru, resFirma, resOlcek, resProjeksiyon] =
          await Promise.all([
            serviceHelper.IlceListesiMultiSelect(res.responseData.model?.projeIlStr),
            serviceHelper.MahalleListesiMultiSelect(res.responseData.model?.projeIlceStr),
            DataService.post(`${process.env.REACT_APP_KURUM_NODE_LIST_ENDPOINT}`),
            DataService.get(`${process.env.REACT_APP_ETUT_TUR_LIST_ENDPOINT}`),
            DataService.post(`${process.env.REACT_APP_FIRMA_DROPDOWN_LIST_ENDPOINT}`, {
              limit: 10000,
              orderColumnAndDirection: '2 asc',
            }),
            DataService.get(
              `${process.env.REACT_APP_OLCEK_LIST_ENDPOINT}?etutTuru=${res.responseData.model?.projeEtutTuru}`,
            ),
            DataService.get(`${process.env.REACT_APP_PROJEKSIYON_LIST_ENDPOINT}`),
            getTumIlceler(res.responseData.model?.projeIlStr),
            getTumMahalleler(res.responseData.model?.projeIlceStr),
          ]);
        setIlceListesi(resIlceListesi);
        setMahalleListesi(resMahalleListesi);
        setKurumListesi(resKurumList.data.model);
        setEtutTuruListesi(resEtutTuru.data.model);
        setFirmaListesi(resFirma.data.model);
        setOlcekListesi(resOlcek.data.model);
        setProjeksiyonListesi(resProjeksiyon.data.model);

        setContentType(2);
      }
      setLoading(false);
    }
    setLoading(false);
  };

  const UpdateIlce = async (ilId) => {
    if (ilId.length === 0) {
      formProjeGuncelle.setFieldsValue({
        IlceIdStr: [],
        MahalleIdStr: [],
      });
      setIlceListesi([]);
      setMahalleListesi([]);
      return;
    }

    const ilIdStr = ilId.join(',');
    const response = await serviceHelper.IlceListesiMultiSelect(ilIdStr);

    const currentIlceValues = formProjeGuncelle.getFieldValue('IlceIdStr') || [];
    const validIlceIds = response.map((ilce) => ilce.ilceKod);
    const filteredIlceValues = currentIlceValues.filter((id) => validIlceIds.includes(id));

    formProjeGuncelle.setFieldsValue({
      IlceIdStr: filteredIlceValues,
      // MahalleIdStr: [],
    });

    setIlceListesi(response);
    // setMahalleListesi([]);
  };

  const UpdateMahalle = async (ilceId) => {
    if (ilceId.length === 0) {
      formProjeGuncelle.setFieldsValue({
        MahalleIdStr: [],
      });
      setMahalleListesi([]);
      return;
    }

    const ilceIdStr = ilceId.join(',');
    const response = await serviceHelper.MahalleListesiMultiSelect(ilceIdStr);

    const currentMahalleValues = formProjeGuncelle.getFieldValue('MahalleIdStr') || [];
    const validMahalleIds = response.map((mahalle) => mahalle.mahalleKod);
    const filteredMahalleValues = currentMahalleValues.filter((id) => validMahalleIds.includes(id));

    formProjeGuncelle.setFieldsValue({
      MahalleIdStr: filteredMahalleValues,
    });

    setMahalleListesi(response);
  };

  const updateOlcek = async (etutTuru) => {
    setLoading(true);
    formProjeGuncelle.resetFields(['OlcekId']);
    const res = await DataService.get(`${process.env.REACT_APP_OLCEK_LIST_ENDPOINT}?etutTuru=${etutTuru}`);
    setOlcekListesi(res.data.model);
    setLoading(false);
  };

  const kaydet = async () => {
    setLoading(true);
    const values = formHelper.getFormValues(formProjeGuncelle);
    if (!formHelper.isEmptyFieldVal(values)) {
      const formValues = {
        ...values,
        ProjeIdStr: projeBilgileri?.projeStr,
        OlcekId: olcekListesi.find((item) => item.value == values.OlcekId).key,
        IlIdStr: diziBirlestir(values.IlIdStr),
        IlceIdStr: diziBirlestir(values.IlceIdStr),
        MahalleIdStr: diziBirlestir(values.MahalleIdStr),
      };
      const res = await formHelper.formSubmit(
        `${process.env.REACT_APP_ADMIN_PROJE_UPDATE_ENDPOINT}`,
        formValues,
        'put',
        true,
      );
      // if (res.responseData.success) {
      //   formProjeGuncelle.resetFields();
      //   setContentType(1);
      // }
    }
    setLoading(false);
  };

  const renderContent = () => {
    switch (contentType) {
      case 1:
        return (
          <Form form={formBarkodNo} layout="vertical">
            <Col xs={24}>
              <Form.Item name="barkodNumarasi" label={t('projeTonetimi.questions.q1')} className="input-sm">
                <Input style={{ padding: '6.5px 20px' }} />
              </Form.Item>
            </Col>
            <Row justify="center">
              <Button
                onClick={() => {
                  projeyiBul();
                }}
                type="success"
                size="default"
              >
                {t('projeTonetimi.button')}
              </Button>
            </Row>
          </Form>
        );
      case 2:
        return (
          <Form key={projeBilgileri?.projeStr} form={formProjeGuncelle} layout="vertical">
            <Form.Item name="ProjeAdi" label={t('projeTonetimi.form2.projeAdi')}>
              <Input placeholder="" />
            </Form.Item>
            <Form.Item className="ninjadash-icon-left" name="IlIdStr" label={t('il')}>
              <Select
                mode="multiple"
                onChange={UpdateIlce}
                className="ninjadash-fullwidth-select"
                showSearch
                getPopupContainer={(trigger) => trigger.parentNode}
                optionFilterProp="children"
                tagRender={({ value, closable, onClose }) => {
                  const found = ilListesi.find((m) => m.key == value); // key'e göre arama yapıyoruz
                  return (
                    <Tag closable={closable} onClose={onClose} style={{ marginRight: 3 }}>
                      {found ? found.value : value} {/* value yerine 'value' kullanılıyor */}
                    </Tag>
                  );
                }}
                filterOption={(input, option) =>
                  deburr(option.props.children).toLowerCase().indexOf(deburr(input).toLowerCase()) >= 0
                }
              >
                {ilListesi &&
                  ilListesi.map((il) => (
                    <Option value={il.key}>{il.value}</Option> // key=il.key, value=il.value olacak
                  ))}
              </Select>
            </Form.Item>
            <Form.Item className="ninjadash-icon-left" name="IlceIdStr" label={t('ilce')}>
              <Select
                mode="multiple"
                onChange={UpdateMahalle}
                className="ninjadash-fullwidth-select"
                showSearch
                getPopupContainer={(trigger) => trigger.parentNode}
                optionFilterProp="children"
                tagRender={({ value, closable, onClose }) => {
                  const found = ilceListesi.find((m) => m.ilceKod === value);
                  return (
                    <Tag closable={closable} onClose={onClose} style={{ marginRight: 3 }}>
                      {found ? found.Ad : value}
                    </Tag>
                  );
                }}
                filterOption={(input, option) =>
                  deburr(option.props.children).toLowerCase().indexOf(deburr(input).toLowerCase()) >= 0
                }
              >
                {ilceListesi && ilceListesi.map((ilce) => <Option value={ilce.ilceKod}>{ilce.Ad}</Option>)}
              </Select>
            </Form.Item>
            <Form.Item className="ninjadash-icon-left" name="MahalleIdStr" label={t('mahalle')}>
              <Select
                mode="multiple"
                className="ninjadash-fullwidth-select"
                showSearch
                getPopupContainer={(trigger) => trigger.parentNode}
                optionFilterProp="children"
                tagRender={({ value, closable, onClose }) => {
                  const found = mahalleListesi.find((m) => m.mahalleKod === value);
                  return (
                    <Tag closable={closable} onClose={onClose} style={{ marginRight: 3 }}>
                      {found ? found.Ad : value}
                    </Tag>
                  );
                }}
                filterOption={(input, option) =>
                  deburr(option.props.children).toLowerCase().indexOf(deburr(input).toLowerCase()) >= 0
                }
              >
                {mahalleListesi &&
                  mahalleListesi.map((mahalle) => <Option value={mahalle.mahalleKod}>{mahalle.Ad}</Option>)}
              </Select>
            </Form.Item>
            <Form.Item className="ninjadash-icon-left" name="KontrolKurumuIdStr" label={t('kontrolKurumu')}>
              <Select
                className="ninjadash-fullwidth-select"
                showSearch
                getPopupContainer={(trigger) => trigger.parentNode}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  deburr(option.props.children).toLowerCase().indexOf(deburr(input).toLowerCase()) >= 0
                }
              >
                {kurumListesi && kurumListesi.map((kurum) => <Option value={kurum.Id}>{kurum.Ad}</Option>)}
              </Select>
            </Form.Item>
            <Form.Item className="ninjadash-icon-left" name="EtutTuruId" label={t('proje.etudTur')}>
              <Select
                onChange={updateOlcek}
                className="ninjadash-fullwidth-select"
                showSearch
                getPopupContainer={(trigger) => trigger.parentNode}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  deburr(option.props.children).toLowerCase().indexOf(deburr(input).toLowerCase()) >= 0
                }
              >
                {etutTuruListesi && etutTuruListesi.map((etut) => <Option value={etut.key}>{etut.value}</Option>)}
              </Select>
            </Form.Item>
            <Form.Item className="ninjadash-icon-left" name="FirmaIdStr" label={t('firma.firmaAdi')}>
              <Select
                className="ninjadash-fullwidth-select"
                showSearch
                getPopupContainer={(trigger) => trigger.parentNode}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  deburr(option.props.children).toLowerCase().indexOf(deburr(input).toLowerCase()) >= 0
                }
              >
                {firmaListesi && firmaListesi.map((firma) => <Option value={firma.Id}>{firma.FirmaAdi}</Option>)}
              </Select>
            </Form.Item>
            <Form.Item className="ninjadash-icon-left" name="OlcekId" label={t('detay.olcek')}>
              <Select
                className="ninjadash-fullwidth-select"
                showSearch
                getPopupContainer={(trigger) => trigger.parentNode}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  deburr(option.props.children).toLowerCase().indexOf(deburr(input).toLowerCase()) >= 0
                }
              >
                {olcekListesi && olcekListesi.map((olcek) => <Option value={olcek.value}>{olcek.value}</Option>)}
              </Select>
            </Form.Item>
            <Form.Item className="ninjadash-icon-left" name="ProjeksiyonId" label={t('detay.projeksiyon')}>
              <Select
                className="ninjadash-fullwidth-select"
                showSearch
                getPopupContainer={(trigger) => trigger.parentNode}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  deburr(option.props.children).toLowerCase().indexOf(deburr(input).toLowerCase()) >= 0
                }
              >
                {projeksiyonListesi && projeksiyonListesi.map((pro) => <Option value={pro.key}>{pro.value}</Option>)}
              </Select>
            </Form.Item>
            <Row justify="center">
              <Button
                onClick={() => {
                  kaydet();
                }}
                type="success"
                size="default"
              >
                {t('kaydet')}
              </Button>
            </Row>
          </Form>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    const operations = async () => {
      const ilList = await getIlList();
      setIlListesi(ilList);

      setLoading(false);
    };
    operations();
  }, []);

  useEffect(() => {
    const selectedIlIds = projeBilgileri?.projeIlStr.split(',').map((id) => parseInt(id.trim()));

    formProjeGuncelle.setFieldsValue({
      ProjeAdi: projeBilgileri?.projeAdi,
      IlIdStr: selectedIlIds,
      IlceIdStr: projeBilgileri?.projeIlceStr.split(','),
      MahalleIdStr: projeBilgileri?.projeMahalleStr.split(','),
      KontrolKurumuIdStr: projeBilgileri?.projeKontrolKurumuStr,
      EtutTuruId: projeBilgileri?.projeEtutTuru,
      FirmaIdStr: projeBilgileri?.projeFirmaStr,
      OlcekId: projeBilgileri?.projeOlcekStr,
      ProjeksiyonId: projeBilgileri?.projeProjeksiyon,
    });

    if (projeBilgileri?.projeIlceStr) {
      UpdateIlce(projeBilgileri?.projeIlStr.split(','));
    }
    if (projeBilgileri?.projeIlceStr) {
      UpdateMahalle(projeBilgileri?.projeIlceStr.split(','));
    }
  }, [contentType]);

  return (
    <Modal
      maskClosable={false}
      visible={visible}
      title={t('projeTonetimi.title')}
      footer={null}
      width="50%"
      onCancel={onCancel}
    >
      {loading && (
        <SpinerCustomStyle>
          <Spin />
        </SpinerCustomStyle>
      )}
      <Row gutter={25}>
        <Col xs={24}>{renderContent()}</Col>
      </Row>
    </Modal>
  );
}

ProjeYonetimi.propTypes = {
  onCancel: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
};

export default ProjeYonetimi;
